import { render, staticRenderFns } from "./FloatButton.vue?vue&type=template&id=d2d5d20c&scoped=true"
import script from "./FloatButton.vue?vue&type=script&lang=ts"
export * from "./FloatButton.vue?vue&type=script&lang=ts"
import style0 from "./FloatButton.vue?vue&type=style&index=0&id=d2d5d20c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d5d20c",
  null
  
)

export default component.exports